import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DipSwitchHelper from './DipSwitchHelper';

interface DeviceOverview {
  name: string;
  switchCount: number;
  decimalValue: number;
}

const TechnicianView: React.FC = () => {
  const { encodedConfig } = useParams<{ encodedConfig: string }>();
  const [deviceConfigs, setDeviceConfigs] = useState<DeviceOverview[]>([]);
  const [showHexBinary, setShowHexBinary] = useState<boolean>(false);
  const navigate = useNavigate();

  // Decode and load the devices overview data from the URL
  useEffect(() => {
    if (encodedConfig) {
      try {
        const decodedConfig = JSON.parse(atob(encodedConfig));
        setDeviceConfigs(decodedConfig);
      } catch (error) {
        console.error('Failed to decode config:', error);
      }
    }
  }, [encodedConfig]);

  const handleToggleHexBinary = () => {
    setShowHexBinary(!showHexBinary);
  };

  const handleRedirectToOriginal = () => {
    navigate('/'); // Assuming the original site is at the root path
  };

  if (deviceConfigs.length === 0) {
    return <div>Loading configuration...</div>;
  }

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Devices Overview (Read-Only)</h1>
      <div className="mb-4 space-x-4">
        <button
          onClick={handleToggleHexBinary}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
        >
          {showHexBinary ? 'Hide' : 'Show'} Hex/Binary
        </button>
        <button
          onClick={handleRedirectToOriginal}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
        >
          Go to Original Site
        </button>
      </div>
      {deviceConfigs.map((device, index) => (
        <div key={index} className="mb-6">
          <h2 className="text-xl font-semibold mb-2">{device.name}</h2>
          <DipSwitchHelper
            switchCount={device.switchCount}
            initialValue={device.decimalValue}
            editable={false}
            showHexBinary={showHexBinary}
          />
        </div>
      ))}
    </div>
  );
};

export default TechnicianView;